// Standard format types applied via data-clientstate-format attribute.
// Supported formats:
//   date:DD.MM.YYYY | date:YYYY-MM-DD | date:MM/DD/YYYY
//   number:2         — 2 decimal places (e.g. 1234.50)
//   number:2:k       — thousands scale (e.g. 1000 → 1.00)
//   number:2:m       — millions scale (e.g. 1000000 → 1.00)
//   percent:0         — value × 100 with % sign (e.g. 0.94 → 94%)
//   percent:2         — with decimals (e.g. 0.9423 → 94.23%)
//   currency:RUB     — via Intl.NumberFormat
//   currency:USD     — via Intl.NumberFormat
const _standardFormatters = {
	date: function (rawValue, params) {
		if (rawValue == null || rawValue === '') return '';
		var d = rawValue instanceof Date ? rawValue : new Date(rawValue);
		if (isNaN(d.getTime())) return rawValue != null ? String(rawValue) : '';
		var pattern = params[0] || 'DD.MM.YYYY';
		var dd = ('0' + d.getDate()).slice(-2);
		var mm = ('0' + (d.getMonth() + 1)).slice(-2);
		var yyyy = d.getFullYear();
		return pattern
			.replace('DD', dd)
			.replace('MM', mm)
			.replace('YYYY', yyyy);
	},
	number: function (rawValue, params) {
		var num = Number(rawValue);
		if (isNaN(num)) return rawValue != null ? String(rawValue) : '';

		var decimals = params[0] != null ? parseInt(params[0], 10) : 0;
		var scale = (params[1] || '').toLowerCase();
		var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();

		// Масштабирование: k = тысячи, m = миллионы
		if (scale === 'k') {
			num = num / 1000;
		} else if (scale === 'm') {
			num = num / 1000000;
		}

		var isNeg = num < 0;
		var abs = Math.abs(num);

		var formatted;
		try {
			formatted = new Intl.NumberFormat(lang || undefined, {
				minimumFractionDigits: decimals,
				maximumFractionDigits: decimals,
				useGrouping: true
			}).format(abs);
		} catch (e) {
			formatted = abs.toFixed(decimals);
		}

		return isNeg ? '(' + formatted + ')' : formatted;
	},
	percent: function (rawValue, params) {
		var num = Number(rawValue);
		if (isNaN(num)) return rawValue != null ? String(rawValue) : '';

		var decimals = params[0] != null ? parseInt(params[0], 10) : 0;
		var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();

		try {
			return new Intl.NumberFormat(lang || undefined, {
				style: 'percent',
				minimumFractionDigits: decimals,
				maximumFractionDigits: decimals
			}).format(num);
		} catch (e) {
			return (num * 100).toFixed(decimals) + '%';
		}
	},
	currency: function (rawValue, params) {
		var num = Number(rawValue);
		if (isNaN(num)) return rawValue != null ? String(rawValue) : '';
		var currencyCode = params[0] || 'USD';
		var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
		try {
			return new Intl.NumberFormat(lang || undefined, { style: 'currency', currency: currencyCode }).format(num);
		} catch (e) {
			return num.toFixed(2);
		}
	}
};

function applyStandardFormat(node, rawValue) {
	var formatAttr = node.getAttribute('data-clientstate-format');
	if (!formatAttr) return rawValue != null ? String(rawValue) : '';

	var colonIdx = formatAttr.indexOf(':');
	var type, params;
	if (colonIdx >= 0) {
		type = formatAttr.substring(0, colonIdx);
		params = formatAttr.substring(colonIdx + 1).split(':');
	} else {
		type = formatAttr;
		params = [];
	}

	var formatter = _standardFormatters[type];
	if (formatter) {
		return formatter(rawValue, params);
	}

	return rawValue != null ? String(rawValue) : '';
}

// Central function for updating a DOM node's display value from state.
// Pipeline: rawValue → ctrl.formatters[propName] → ctrl.fields[propName] → data-clientstate-format → statevalue event → DOM
function setNodeDisplayValue(node, rawValue, ctrlInst, propName) {
	var formatted = null;

	// 1. Check ctrl-level formatter (imperative, defined in init)
	if (ctrlInst && ctrlInst.formatters && typeof ctrlInst.formatters[propName] === 'function') {
		formatted = ctrlInst.formatters[propName](rawValue);
	}

	// 1.5. Field metadata lookup (dropdown label from items, checkbox Yes/No)
	if (formatted === null && ctrlInst && ctrlInst.fields && ctrlInst.fields[propName]) {
		var fc = ctrlInst.fields[propName];
		if (fc.control === 'dropdown' && fc.items) {
			for (var i = 0; i < fc.items.length; i++) {
				if (String(fc.items[i].value) === String(rawValue)) {
					formatted = fc.items[i].label;
					break;
				}
			}
		} else if (fc.control === 'checkbox') {
			formatted = rawValue ? 'Yes' : 'No';
		}
		// datepicker — falls through to standard date formatter below
	}

	// 2. Apply standard format from data-attribute (if no ctrl formatter or field lookup)
	if (formatted === null) {
		if (node.hasAttribute('data-clientstate-format')) {
			formatted = applyStandardFormat(node, rawValue);
		}
	}

	// 3. Dispatch custom event for external handlers
	var evt = new CustomEvent('statevalue', {
		bubbles: false,
		detail: { rawValue: rawValue, formattedValue: formatted }
	});
	node.dispatchEvent(evt);

	// 4. If any handler overrode the value, use it
	if (evt.detail.formattedValue !== null) {
		formatted = evt.detail.formattedValue;
	}

	// 5. Determine final display value
	var displayValue = formatted != null ? formatted : (rawValue != null ? rawValue : '');

	// 6. Write to DOM
	if (node instanceof HTMLInputElement || node instanceof HTMLSelectElement || node instanceof HTMLTextAreaElement) {
		node.value = displayValue;
	} else {
		node.textContent = displayValue;
	}
}

module.exports = { setNodeDisplayValue };